import type * as Flows from './types.no-deps'
import { currentAnswerIsEmpty, findAnswer } from './answer.no-deps'
import { findElement, getAllElementsOrderedByDisplay } from './element.no-deps'
import { findChoiceLabel } from './choice.no-deps'
import type { Nullable } from '../../lib/typeHelpers.no-deps'
import { identity } from '../../lib/functional/function.no-deps'

function getReportTitleV1(flow: Flows.Flow, flowSummary: Flows.FlowSummary): string {
    if (flow.titleAssigningElement == null) return null

    const answer = findAnswer(flowSummary.answers, flow.titleAssigningElement, [])
    if (currentAnswerIsEmpty(answer)) return null

    const element = findElement(flow, flow.titleAssigningElement)

    return getElementValue(element.id, flow, flowSummary)
}

export function getReportTitle(
    flow: Flows.Flow,
    flowSummary: Flows.FlowSummary,
    workflowName: Nullable<string>,
    appendToReportTitleFlagEnabled: boolean
): Nullable<string> {
    if (!appendToReportTitleFlagEnabled) {
        return getReportTitleV1(flow, flowSummary)
    }

    const titleAssigningElementValue = getElementValue(flow.titleAssigningElement, flow, flowSummary)
    const baseTitle = !titleAssigningElementValue && workflowName ? workflowName : titleAssigningElementValue

    if (!flow.titleAppendingElements?.length || !flowSummary.answers.length) {
        return baseTitle
    }

    const titleParts = getAllElementsOrderedByDisplay(flow).reduce(
        (accum, element) => {
            if (flow.titleAppendingElements.includes(element.id)) {
                return accum.concat(getElementValue(element.id, flow, flowSummary))
            }

            return accum
        },
        [baseTitle]
    )

    return titleParts.filter(identity).join(' - ')
}

function getElementValue(elementId: Nullable<Flows.ElementId>, flow: Flows.Flow, flowSummary: Flows.FlowSummary) {
    if (elementId === null) {
        return null
    }

    const answer = findAnswer(flowSummary.answers, elementId, [])
    if (currentAnswerIsEmpty(answer)) {
        return null
    }

    const element = findElement(flow, elementId)

    switch (answer.type) {
        case 'dropdown':
            if (element.type !== 'dropdown') return null
            return findChoiceLabel(element.choices, answer.value[0])

        case 'image-select':
            if (element.type !== 'image-select') return null
            return findChoiceLabel(element.choices, answer.value[0])

        case 'radio':
            if (element.type !== 'radio') return null
            return findChoiceLabel(element.choices, answer.value)

        case 'text-capture':
            if (element.type !== 'text-capture') return null
            return answer.value.replace(/\r?\n/g, ' ').trim()
    }
}
